import { dispatch, getState } from '../../..';
import PumpingStationPumpTypeHelper, { IPumpingStationPumpType } from '../../../../@types/model/masterData/pumpingStation/pumpType';
import GeneralFunctions from '../../../general/functions';
import MasterDataPumpingStationPumpTypeActions from './actions';

export default class MasterDataPumpingStationPumpTypeFunctions {
    private static listener : undefined | (() => void);


    public static readonly load = async () => {
        if (MasterDataPumpingStationPumpTypeFunctions.listener) return;
        
        dispatch(MasterDataPumpingStationPumpTypeActions.setLoading(true));
        dispatch(MasterDataPumpingStationPumpTypeActions.set([]));

        try {
            MasterDataPumpingStationPumpTypeFunctions.listener = PumpingStationPumpTypeHelper
                .collection()
                .onSnapshot((snapshot : firebase.firestore.QuerySnapshot<IPumpingStationPumpType>) => {
                    const state = getState().masterData.pumpingStation.pumpType;

                    const list = state.pumpTypes.slice();
                
                    const session = getState().auth.session;
                    if (!session) return;

                    // "added" | "removed" | "modified"
                    snapshot.docChanges().forEach((f) => {
                        const item = f.doc.data();
                        const index = list.findIndex(n => n.id === item.id);


                        switch (f.type) {
                            case 'added':
                                list.push(item);
                                break;
                            case 'modified':
                                list.splice(index, 1, item);
                                break;
                            case 'removed':
                                list.splice(index, 1);
                                break;
                        }
                    });

                    dispatch(MasterDataPumpingStationPumpTypeActions.set(list));
                    dispatch(MasterDataPumpingStationPumpTypeActions.setLoading(false));
                }, (ex) => {
                    GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
                    dispatch(MasterDataPumpingStationPumpTypeActions.setLoading(false));
                }, () => {
                    dispatch(MasterDataPumpingStationPumpTypeActions.setLoading(false));
                    MasterDataPumpingStationPumpTypeFunctions.listener = undefined;
                });

        } catch (ex) {
            GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
            dispatch(MasterDataPumpingStationPumpTypeActions.setLoading(false));
        }
    };
}